import { useFrame, useLoader } from "@react-three/fiber"
import { motion } from "framer-motion-3d";
import { useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { CityName } from "./CityName";
import { useBodyClass } from "../utils/hook";

export default function Weather(props) {
    const { weather, name, position, rotation } = props;
    const gltf = useLoader(GLTFLoader, `${process.env.PUBLIC_URL}/assets/model/weather.glb`)
    const ref = useRef(null)

    const navigate =  useNavigate()

    const [isHover, setHover] = useState(false);

    const [path, setPath] = useState('');

    const weatherModel = useMemo(() => {
        const clonedModel = gltf.nodes[weather] || gltf.nodes.cloud
        return clonedModel.clone()
    }, [weather])

    useEffect(()=> {
        if (name) {
            const formattedName = name.replace(/\s/g, '').toLowerCase();
            setPath(formattedName);
        }
    },[name])

    useFrame((_, delta)=>{
        if(ref.current) ref.current.rotation.y += delta;
    })

    const scale = useMemo(() => [7, 7, 7], []);

    const onClick = () => {
        navigate(`/${path}`)
    }

    useBodyClass(isHover, "pointer")

    return (
        <> 
            {weatherModel ? 
                (
                    <motion.group
                    position={position}
                    rotation={rotation}>
                        <motion.mesh 
                            onPointerEnter={()=> setHover(true)}
                            onPointerOut={()=> setHover(false)}
                            whileHover={{scale:8.5, transition:{duration:0.5}}}
                            onClick={onClick}
                            ref={ref}
                            scale={scale}>
                            <primitive object={weatherModel} />
                        </motion.mesh>
                        {isHover ? <CityName name={name}/> : null}
                    </motion.group>
                ): null
            }
        </>
    )
}